<template>
  <div class="report-container">
    <div
      ref="report-mask"
      class="report-mask"
      :code="code"
      :loading="loading"
    >
    </div>
    <div
      ref="report-warrper"
      :reportCode="code"
      @keyup.enter.stop="submitMethod"
      class="report-warrper"
    >
      <report-header
        :title="title"
        :code="code"
        :buttons="buttons"
        :isDialog="isDialog"
        :radioCheckedValue="radioValue"
        :checkeboxChecked="checked"
        @button-method="buttonMethod"
        @refresh="refresh"
      ></report-header>
      <report-info-bar :data="infoBar" v-if="infoBar && infoBar.position ==='top'"></report-info-bar>
      <report-params
        ref="queryParams"
        @clearReport="clearReportParams"
        :code="code"
        :paramsModel="params"
        :type="type"
        v-model="searchData"
        :resouceType="report = 'report'"
        @confirm="refresh"
        :script="script"
        :autoFocus="autoFocus"
      ></report-params>
      <report-info-bar :data="infoBar" v-if="infoBar && infoBar.position ==='middle'">
      </report-info-bar>
      <report-table
        ref="reportTable"
        :tableColumns="columns"
        :tableData="gridData"
        :indexH="configH"
        :reportCode="code"
        :searchData="searchData"
        :current-page="pageNo"
        :page-size="pageSize"
        :paramsHeight=paramsHeight
        @refresh="refresh"
        @sort="handlerSort"
        @checkBoxChange="handlerChangeCheckbox"
        @radioChecked="radioChecked"
        :radioCheckedValue="radioCheckedValue"
        :select-on-indeterminate="false"
        :radioIndex="radioIndex"
        :subTable="subTable"
        :columnExp="columnExp"
      >
      </report-table>
    </div>
    <div class="report-info-all"
      v-if="hasPage"
    >
      <!--<report-info-bar-->
        <!--v-if="testInfoData"-->
        <!--:data="testInfoData"-->
      <!--&gt;</report-info-bar>-->
      <report-pagination
        ref="pagination"
        :current-page=pageNo
        :page-size="pageSize * 1"
        :page-sizes=pageSizes
        :total=totalRows
        :layout="page.layout || defaultLayout"
        @sizeChange="handlerSizeChange"
        @currentChange="handlerCurrentChange"
      ></report-pagination>
      <!--<pre :id="code+'-hide-label'" style=" font-family: inherit;display: inline-block;position: fixed;position: fixed;visibility:hidden;top: 100px;right: 200px;font-size: 12px;padding-left: 2px;padding-right: 2px"></pre>-->
    </div>
  </div>
</template>
<script>
  import reportHeader from './components/reportHeader.vue'
  import { getReportMetaData, getReportData, ajaxSendBatch, exportSend, getInfoForExport } from '@/api/report.js'
  import { methodPost, methodGet } from '@/api/request.js'
  import { printOrderPC } from '@/utils/utilsOnlyForPC.js'
  import { starOutRequestLoading as starLoading, closeOutRequestLoading as closeLoading } from '@/utils/loading.js'
  import reportParams from './components/reportParams.vue'
  import reportPagination from './components/reportPagination.vue'
  import reportInfoBar from './components/reportInfo.vue'
  import helpService from '@/utils/manager'
  const defaultPageSizes = [100, 200]
  const defaultPageSize = 100
  import dynamicColumnsMixin from '@/mixins/dynamicColumns.js';
  // import _ from 'lodash'
/* eslint-disable */
  // import XLSX from 'xlsx'
/* eslint-disable */
  var FileSaver = require('file-saver')
  export default {
    name: 'report',
    mixins:[dynamicColumnsMixin],
    props: {
      code: {
        type: String
      },
      meta:{
        type: Object
      },
      update: Object | undefined | String,
      infoBar: Object,
      // dynamicColumnNames: Array,
      title: String,
      buttons: Array,
      params: Array,
      columns: Array,
      columnExp: String,
      path: String,
      configH: String,
      value: String,
      type: String,
      css: String,
      script: String,
      isDialog: {
        required: false
      },
      staticParams: {
        type: Object,
        default: function() {
          return {}
        }
      },
      checkeds: {
        type: Array,
        default() {
          return []
        }
      },
      radioCheckedValue: {
        type: Object,
        default() {
          return {}
        }
      },
      autoFocus: {
        type: Boolean,
        default: false
      },
      subTable: {
        type: Object
      },
      autoLoad: {
        type: Boolean,
        default: true
      },
      initCheckboxVal:{
        type: Array
      },
      page: {
        type: Object | Boolean,
        default() {
          return {
            layout: 'total, sizes, prev, pager, next, jumper',
            pageSize: defaultPageSize,
            pageSizes: defaultPageSizes
          }
        }
      }
    },
    computed:{
      hasPage() {
        if (!this.page) {
          return false
        } else {
          return true
        }
      }
    },
    components: {
      'report-header': reportHeader,
      reportParams,
      reportPagination,
      reportInfoBar
    },
    beforeMount() {
      this.$bus.$off('refresh-grid', this.refreshGridData)
      this.$bus.$on('refresh-grid', this.refreshGridData)
      const helpSpace = window.helpSpace || {}
      if (!helpSpace[this.code]) {
        helpSpace[this.code] = {}
      }
      helpSpace[this.code]['report'] = helpService.getReport(this)
      window.helpSpace = helpSpace
      helpService.dealCss(this.code, this.css)
      helpService.dealScript(this.code, this.script)
    },
    data() {
      this.defaultLayout = 'total, sizes, prev, pager, next, jumper'
      this.pageSizes = this.page.pageSizes || defaultPageSizes
      this.columnMaping = {}
      return{
        // isInitView: true,
        loading: true,
        loadingData: false,
        reportData: {},
        gridData: [],
        searchData: {},
        paramsHeight: 0,
        sort: '',
        pageSize: this.page.pageSize || defaultPageSize,
        pageNo: 1,
        totalRows: 0,
        totalPages: 0,
        testInfoData: {},
        checked: [],
        radioValue: {},
        checkedFlag: Object.freeze(false),
        checkedAllObjct: {},
        setBackNum: 0,
        radioIndex: null,
        searchDataClone: {}, // 复制searchData
        firstIn: 1,// 第一次进入该列表的时候复制searchData
        firstGetData: true,
        timeOutNumbers: [] // 定时器的number，记录清除使用
        // ,
        // dynamicColumnNames:[]
      }
    },
    activated() {
      // console.error('activated')
      if(!this.firstGetData){ // 从别的页面进来关闭loading
        closeLoading()
      }
      if (this.$route.query.method === 'update') {
        this.getData()
      }
      // // 切换面包屑 刷新功能
      if (this.update && this.update.method === 'updatelist' ) {
        this.getData()
      }
      // // 详情页点击进入列表页带入参数
      if (this.$store.state.report.params.configKey == this.$route.path) {
        this.getData()
      }
    },
    beforeDestroy() {
      // 处理新增界面 表单弹框出现后 返回列表页刷新不对的问题
      this.$bus.$off('refresh-grid', this.refreshGridData)
      helpService.removeScriptOrCss(this.code)
    },
    mounted() {
      if (this.hasPage) {
        this.paramsHeight = this.$refs.pagination.$el.offsetHeight
        // this.$bus.$emit('reisize-report-' + this.code, this.paramsHeight)
      }
      this.$el.addEventListener('copy', (e) => {
        this.addCopyMessage(e)
      })
    },
    watch: {
      path: {
        handler(val) {
          this.$nextTick(() => {
            this.dealQueryData()
          })
          if (this.autoLoad) {
            this.$nextTick(() => {
              this.getData()
            })
          }
        },
        deep: true,
        immediate: true
      },
      checkeds: {
        handler(val) {
          this.$refs.reportTable && this.$refs.reportTable.clearSelection()
          this.setChecked(val)
        },
        deep: true,
        immediate: true
      },
      gridData: {
        handler(val) {
          this.$nextTick(() => {
            this.checkeds.length > 0 && this.setChecked(this.checkeds)
            !_.isEmpty(this.radioCheckedValue) && this.dealRadioChecked()
          })
        }
      },
      columns: {
        handler(val) {
          if (val) {
            val.forEach(column => {
              this.columnMaping[column['name']] = column
            })
          }
        },
        deep: true,
        immediate: true
      },
      // params: {
      // handler(val) {
      // this.$nextTick(() => {
      // if (!this.loadingData) {
      // this.getData()
      // }
      // })
      // },
      // deep: true,
      // immediate: true
      // }
      params: {
        handler(val) {
          this.$nextTick(() => {
            this.dealQueryData()
            this.getData()
          })
        },
        deep: true
      }
    },
    methods: {
      resetCheckeds() {
        this.$refs.reportTable.clearSelection()
        this.radioIndex = null
      },
      setChecked(rows) {
        this.$nextTick(() => {
          this.$refs.reportTable.setCheckeds(this.dealKeys(rows, this.gridData))
        })
      },
      dealKeys(checkedRows, data) {
        const returnCheckeds = []
        data.forEach(item => {
          checkedRows.forEach(dataItem => {
            let flat = true
            for (const i in dataItem) {
              if (typeof dataItem[i] === 'object') {
                if (dataItem[i].value !== item[i].value) {
                  flat = false
                }
              } else {
                if (dataItem[i] !== item[i] && i !== 'key') {
                  flat = false
                }
              }
            }
            if (flat) {
              returnCheckeds.push(item)
            }
          })
        })
        return returnCheckeds
      },
      dealRadioChecked() {
        this.gridData.forEach((item) => {
          let flat = true
          for (const i in this.radioCheckedValue) {
            if (typeof this.radioCheckedValue[i] === 'object') {
              if (this.radioCheckedValue[i].value !== item[i].value) {
                flat = false
              }
            } else {
              if (this.radioCheckedValue[i] !== item[i] && i !== 'key') {
                flat = false
              }
            }
          }
          if (flat) {
            this.radioIndex = item.key
          }
        })
      },
      radioChecked(val) {
        this.radioValue = val
        this.$emit('radioChecked', val)
      },
      handlerChangeCheckbox(val) {
        if (this.checkedFlag) {
          this.checkedFlag = false
          return
        }
        const numStr = this.pageNo
        if (!this.checkedAllObjct[numStr]) {
          this.checkedAllObjct[numStr] = {}
        }
        this.checkedAllObjct[this.pageNo] = val
        this.checked = val
        this.$emit('checkbox', val)
        // for (var i in this.checkedAllObjct) {
        //   this.checked = this.checked.concat(this.checkedAllObjct[i])
        // }
        // // 添加数组去重
        // const hash = {}
        // this.checked.length && this.checked.reduce((preVal, curVal)=> {
        //   hash[curVal.id] ? '' : hash[curVal.id] = true && preVal.push(curVal)
        //   return preVal
        // },[])
      },
      buttonMethod(event, isDialog) {
        const type = event.type
        this[type + 'Method'] && this[type + 'Method'](event, isDialog)
      },
      ajaxMethod(Nevent,isDialog){
        if(Nevent.requireParams){
          this.$refs.queryParams.confirm(Nevent).then(() => {
            const event = _.cloneDeep(Nevent)
            let params = {
              pageNo: this.pageNo,
              pageSize: this.pageSize,
              sort: this.sort
            }
            params = _.merge({}, this.staticParams, params, this.searchData, this.$route.query)
            this.realSendCustomAjax(Nevent,params)
          })
        }
        else{
          this.realSendCustomAjax(Nevent,{})
        }
      },
      realSendCustomAjax(event,params = {}){
        let fn = methodPost
        if(event.type == 'get'){
          fn = methodGet
        }
        params['targetLoadingDom'] = '.app-main'
        fn(event.path, params).then(res=>{
          if(res.code !== 0){
            if(parseInt(res.code) === 30001){
              this.$message.warning(res.message || '接口访问失败')
            }else {
              this.$message.error(res.message || '接口访问失败')
            }
          }else {
            if(event.callback &&event.callback.showMessage) {
              this.$message.success(res.message || '操作成功')
            }
            if(event.callback &&event.callback.refresh) {
              if(event.callback.refreshCode){
                this.$bus.$emit('refresh-grid',null,event.callback.refreshCode);
              }else{
                this.$bus.$emit('refresh-grid');
              }
            }
          }
        }).catch(err=>{
          this.$message.error(err || '接口访问失败')
        })
      },
      realExportMethod(event) {
        const defaultCellStyle = {
          font: {
            name: 'Verdana',
            sz: 11,
            color: 'FF00FF88'
          },
          fill: {
            fgColor: {
              rgb: 'FFFFAA00'
            }
          }
        }
        const wopts = {
          bookType: 'xlsx',
          bookSST: false,
          type: 'binary',
          defaultCellStyle: defaultCellStyle,
          showGridLines: false
        }
        const wb = {
          SheetNames: ['Sheet1'],
          Sheets: {},
          Props: {}
        }
        const data = _.cloneDeep(this.checked)
        const endData = []
        data.forEach(item => {
          const temp = {}
          for (const i in item) {
            const title = this.columnMaping[i] && this.columnMaping[i]['title']
            if (title) {
              temp[title] = item[i]
            }
          }
          endData.push(temp)
        })
        wb.Sheets['Sheet1'] = XLSX.utils.json_to_sheet(endData)

        // 创建二进制对象写入转换好的字节流
        const tmpDown = new Blob([this.s2ab(XLSX.write(wb, wopts))], { type: 'application/octet-stream' })
        FileSaver.saveAs(tmpDown, event.fileName)
      },
      feExportMethod(event) {
        if (event.confirm) {
          const confirm = event.confirm
          this.$confirm(confirm.message, confirm.title, {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            center: true
          }).then(() => {
            this.realExportMethod(event)
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消操作'
            })
          })
        } else {
          this.realExportMethod(event)
        }
      },
      s2ab(s) {
        if (typeof ArrayBuffer !== 'undefined') {
          const buf = new ArrayBuffer(s.length)
          var view = new Uint8Array(buf)
          for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF
          return buf
        } else {
          const buf = new Array(s.length)
          for (var i = 0; i !== s.length; ++i) buf[i] = s.charCodeAt(i) & 0xFF
          return buf
        }
      },
      yongHongExportMethod(Nevent) {
        const event = _.cloneDeep(Nevent)
        const path = event.path
        const fileName = event.fileName
        let params = {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          sort: this.sort
        }
        params = _.merge({}, this.staticParams, params, this.searchData, this.$route.query)
        let columnParams = {}
        if (this.$parent && this.$parent.$parent && this.$parent.$parent.params) {
          columnParams = this.$parent.$parent.params
        }
        params = _.merge({}, this.staticParams, params, this.searchData, this.$route.query, columnParams)
        getInfoForExport(path, params).then(res => {
          if (res.code === 0) {
            const url = res.data.url;
            var a = document.createElement('a')
              // var url = window.URL.createObjectURL(blob)
              a.href = url
              // a.download = fileName
              a.click()
              // window.URL.revokeObjectURL(url)
            // const token = '825B155E696C24A66BC2FF2EDBF25310'
            // // const xmlData = data.xmlData
            // const xmlData = `<?xml version="1.0" encoding="UTF-8"?>
            //     <info>
            //     <user>zhengwei</user>
            //     <rptPath>品牌商生意分析by子品牌/品牌商生意分析_by省市县/日报/门店数据</rptPath>
            //     <fileType>xls</fileType>
            //     <params>
            //     <param name="id" type="int">1</param>
            //     </params>
            //     </info>`
            // const url = data.url
            // exportForYH(url, xmlData, token).then(resXML => {
            //   const blob = resXML
            //   var a = document.createElement('a')
            //   var url = window.URL.createObjectURL(blob)
            //   a.href = url
            //   a.download = fileName
            //   a.click()
            //   window.URL.revokeObjectURL(url)
            // })
          } else {
            this.$message.error('导出失败请与管理员联系')
          }
        })
      },
      exportMethod(Nevent) {
        this.$refs.queryParams.confirm(event).then(() => {
          const event = _.cloneDeep(Nevent)
          let params = {
            pageNo: this.pageNo,
            pageSize: this.pageSize,
            sort: this.sort
          }
          const path = event.path
          const ajaxType = event.ajaxType
          // 如果后台json没有配置fileName，就用默认的名称
          const fileName = event.fileName || '导出数据.xls'
           if(event.targetLoadingDom){
             params['targetLoadingDom']  = event.targetLoadingDom || '.app-main'
           }
          params = _.merge({}, this.staticParams, params, this.searchData, this.$route.query)
          exportSend(path, ajaxType, params).then(res => {
            const blob = res.data
            var a = document.createElement('a')
            var url = window.URL.createObjectURL(blob)
            a.href = url
            a.download = fileName
            a.click()
            window.URL.revokeObjectURL(url)
          })
        })
      },
      batchMethod(Nevent) {
        const that = this
        const event = _.cloneDeep(Nevent)
        let params = event.params || []
        if (!_.isArray(params)) {
          params = params.split(',')
        }
        const query = []
        if (this.checked.length < 1) {
          this.$message('请选择')
          return
        }
        this.checked.forEach(row => {
          const temp = {}
          params.forEach((item) => {
            temp[item] = row[item]
          })
          query.push(temp)
        })
        event.params = query
        event.url = event.path
        if (event.confirm) {
          const confirm = event.confirm
          this.$confirm(confirm.message, confirm.title, {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            center: true
          }).then(() => {
            that.realSendAjax(event)
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消操作'
            })
          })
        } else {
          that.realSendAjax(query)
        }
      },
      batchRouterMethod(Nevent) { // 列表选中行后跳转页面
        const that = this
        const event = _.cloneDeep(Nevent)
        const params = event.params || []
        const query = []
        if (this.checked.length < 1) {
          this.$message('请选择')
          return
        }
        this.checked.forEach(row => {
          const temp = {}
          params.forEach((item) => {
            temp[item] = row[item]
          })
          query.push(temp)
        })
        event.params = query
        event.url = event.path
        if (event.confirm) {
          const confirm = event.confirm
          this.$confirm(confirm.message, confirm.title, {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            center: true
          }).then(() => {
            that.$router.push({ 'path': event.configKey, 'query': { querys: JSON.stringify(event.params) }})
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消操作'
            })
          })
        } else {
          that.$router.push({ 'path': event.configKey, 'query': ({ querys: JSON.stringify(event.params) }) })
        }
      },
      realSendAjax(query, index) {
        ajaxSendBatch(query).then(res => {
          if (res.code === 0) {
            this.checked = []
            this.$message({
              type: 'success',
              message: '成功',
              showClose: true
            })
            this.refresh().then(() => {
              this.$refs.reportTable.clearSelection()
            })
          } else {
            this.$message({
              type: 'error',
              message: res.message,
              showClose: true
            })
          }
        })
      },
      // 打印按钮事件
      printMethod(Nevent) {
        const params = Nevent.params || []
        const query = []
        const path = Nevent.path || ''
        if (!path) {
          this.$message('请配置接口地址')
          return
        }
        if (!Nevent.templateName) {
          this.$message('请配置打印模板名称')
          return
        }
        if (Nevent.especial) { // 特殊情况，全打印
          if (this.gridData && this.gridData.length > 0) {
            this.gridData.forEach((row) => {
              const temp = {}
              params.forEach((item) => {
                console.log(row)
                temp[item] = row[item]
              })
              query.push(temp)
            })
          } else {
            this.$message('暂无数据，无法打印')
            return
          }
        } else {
          if (this.checked.length < 1) {
            this.$message('请选择')
            return
          }
          this.checked.forEach(row => {
            const temp = {}
            params.forEach((item) => {
              temp[item] = row[item]
            })
            query.push(temp)
          })
        }
        console.log(query)
        methodPost(path, query).then(res => {
          if (res.code === 0) {
            this.printInfo(res.data, Nevent.templateName)
          } else {
            this.$message.error('获取打印数据出错！')
          }
        })
      },
      // PC打印
      printInfo(data, title) {
        const printInfo = JSON.stringify(data)
        const _this = this
        // PC打印回调
        window.printCallback = function(printStatus) {
          if (printStatus === 'true') {
            // 成功回调
          } else {
            _this.$message('打印失败')
          }
        }
        const funcName = 'printCallback'
        printOrderPC(title, printInfo, funcName)
      },
      submitMethod(event) {
        if (event && _.isObject(event.path)) {
          event = undefined
        }

        this.checked = []
        this.pageNo = 1
        this.sort = ''
        // this.$bus.$emit('submitreport' + this.code, event)
        this.$refs.queryParams.confirm(event).then(() => {
          this.refresh(event).then(() => {
            this.checkedFlag = Object.freeze(false)
            this.$refs.reportTable.clearSelection()
          })
        })
      },
      resetMethod(event, isDialog) {
        this.$refs.queryParams.reset(isDialog)
      },
      refresh(event) {
        this.checkedFlag = true
        const that = this
        return new Promise((resolve, reject) => {
          if (event === 'delete' && process.env.PROJECT === 'outlet') {
            // 如果是删除按钮  重新计算页码
            if (that.pageNo === that.totalPages) {
              that.pageNo = Math.ceil((that.totalRows - 1) / that.pageSize)
            }
            that.getData().then((res) => {
              resolve(res)
            })
          } else {
            let promise =  that.getData(event)
            if(promise && promise.then){
              promise.then((res) => {
              resolve(res)
            })}
          }
        })
      },
      getMetaData() {
        const params = {
          code: this.code
        }
        getReportMetaData(params).then((res) => {
          const data = res.data.meta
          this.title = data.title
          this.buttons = data.buttons
          this.params = data.params
          this.columns = data.columns
          this.$nextTick(() => {
            this.getData()
          })
        })
      },
      refreshGridData(event,code,isNeedLoading = false){
        this.realGetData(event,code,isNeedLoading)
      },
      realGetData(event,code,isNeedLoading = true){
        console.error(111,isNeedLoading)
        let noLoading = false
        // const loading = this.$loading({})
        // this.$nextTick(()=>{
        //   loading.close()
        // }
        if(code){ // 有特定的code且不是当前页面
          if(this.code !== code){
            return
          }else{
            noLoading = true
          }
        }

        if (this.loadingData || !this.path) {
          return new Promise((resolve, reject) => {
            resolve()
          })
        }
        this.loadingData = true

        let params = {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          sort: this.sort
        }
        if (this.$route.fullPath.indexOf('/tab') === 0) {
          let queryTab = this.$route.query
          delete(queryTab["method"])
          Object.assign(params, queryTab)
        }
        let path = this.path
        let columnParams = {}
        if(process.env.PROJECT !== 'dealer_pc'){
          if (this.$parent && this.$parent.$parent && this.$parent.$parent.params) {
            columnParams = this.$parent.$parent.params
          }
        }

        // 添加处理存储列表从详情页带来的查询信息
        if (this.$store.state.report.params.configKey == this.$route.path) {
          delete this.$store.state.report.params.configKey
          if (this.firstIn) {
            this.searchDataClone = _.cloneDeep(this.searchData)
            this.firstIn = 0
          }

          Object.assign(this.searchData, this.$store.state.report.params)
          this.$store.dispatch('ReportParams', {})
        } else {
          Object.assign(this.searchData,this.$route.query)
        }

        // params = _.merge({}, this.staticParams, params, this.searchData,columnParams)
        params = _.merge({}, this.staticParams, this.searchData, params, columnParams)
        if (event && event.path) {
          path = event.path
        }
       if(!this.firstGetData && isNeedLoading){ // 第一次请求的时候不需要loading
         starLoading()
       }
        params ['noLoading'] = true
        return new Promise((resolve, reject) => {
          getReportData(path, params).then(res => {
              console.error(res)
              this.firstGetData = false           // this.loadingData = true
              this.dealResData(res)
              closeLoading()
              resolve(res)
          }).catch(errData => {
            this.loadingData = false
            closeLoading()
            // reject(errData)
          })
        })
      },
      // getData: _.throttle(function(event) { 老方法 会触发页面多次请求的问题
      getData: _.debounce(function(event) {
         return this.realGetData(event)
      }, 300),
      dealResData(res){
        if (res.code === 0) {
          const data = res.data
          if (data.info) {
            this.$bus.$emit('report-info-bar-data', data.info)
          }
          if (data.rowName) {
            this.$bus.$emit('report-row-name', data.rowName)
          }
          this.gridData = this.setDataKey(data.data)
          // this.setTimeOutPushData(data.data) // 页面超过500条的时候调用这个方法，通过setTimeOut动态插入一百条
          this.totalRows = data.totalRows
          this.totalPages = data.totalPages
          // setTimeout(()=>{
          this.computerColumnWidth(data.data) // 计算动态宽度方法
          // },0)
          if (this.hasPage) {
            this.pageNo = data.pageNo
          }
          let a = this.meta
          // console.error(a)
          if (this.isDialog && this.meta.returnValue) {
            this.setBackShowChecked(data)
          }

          this.$nextTick(() => {
            this.loadingData = false

          })
        } else {
          this.loadingData = false
          this.$message({
            type: 'error',
            message: res.message,
            showClose: true
          })
        }
      },
      setBackShowChecked(data){
        this.$nextTick(() => {
          let valueName = this.meta.returnValue
          const tmpData = []
          let tmpArr = data.data
          let initArr = this.initCheckboxVal
          if (tmpArr &&  initArr.length> 0) {
            for (let j = initArr.length-1; j >=0; j--) {
              const obj1 = initArr[j]
              for (let i = 0; i < tmpArr.length; i++) {
                const obj2 = tmpArr[i]
                if (obj2[valueName] === obj1[0]) {
                  initArr.splice(j,1)
                  tmpData.push(obj2)
                }
              }
            }
            console.error(tmpData)
            this.setChecked(tmpData)
            // this.checkeds.length = 0
            // this.checkeds.contract tmpData
          }

        })
      },
      // 新增详情进入列表清空默认值的方法
      clearReportParams() {
        if (_.isEmpty(this.searchDataClone)) {

        } else {
          this.searchData = _.cloneDeep(this.searchDataClone)
        }
      },
      setDataKey(data) {
        data.forEach((item, index) => {
          item.key = this.pageNo * this.pageSize + index
        })
        return data
      },
      // 通过setimeout合并数组，减少渲染太多数据导致卡顿
      setTimeOutPushData(data){
        data.forEach((item, index) => {
          item.key = this.pageNo * this.pageSize + index
        })
        const that = this
        if(data.length >= 100){
          let result = []
          const n = 50
          let  len = Math.ceil(data.length/n)
          for(let i=0;i<len;i++){
            let end = n*(i+1)> data.length? data.length:n*(i+1)
            result.push(data.slice(i*n,end));
          }
          this.gridData = []
          this.gridData = this.gridData.concat(result[0])
          that.timeOutNumbers.forEach((timerNumber)=>{
            clearTimeout(timerNumber)
          })
          that.timeOutNumbers = []
          for(let i = 1;i<result.length;i++){
            (function(a){
              let timer = setTimeout(()=>{
                that.gridData = that.gridData.concat(a)
                console.error('timer ',timer )
              },1)
              that.timeOutNumbers.push(timer)
            })(result[i])
          }
        }else{
          this.gridData = data
        }
        return data
      },
      dealQueryData(row) {
        const model = {}
        if (this.params) {
          this.params.forEach((item, index) => {
            model[item.name] = item.value || ''
          })
          this.searchData = model
        }
      },
      handlerSizeChange(val) {
        window.localStorage.setItem(this.$route.path, val)
        this.pageSize = val
        this.pageNo = 1
        if (this.$refs.queryParams) {
          this.$refs.queryParams.confirm().then(res => {
            if (res.flag) {
              this.getData()
            }
          })
        } else {
          this.getData()
        }
      },
      // 当前展示的页数
      handlerCurrentChange(val) {
        this.pageNo = val
        if (this.$refs.queryParams) {
          this.$refs.queryParams.confirm().then(res => {
            if (res.flag) {
              this.getData()
            }
          })
        } else {
          this.getData()
        }
      },
      handlerSort(val) {
        this.sort = ''
        if (val && val.prop) {
          // this.sort[val.prop] = val.order
          this.sort = val.prop + ' ' + val.order
        }
        if (this.$refs.queryParams) {
          this.$refs.queryParams.confirm().then(res => {
            if (res.flag) {
              this.getData()
            }
          })
        } else {
          this.getData()
        }
      },
      addCopyMessage(e) {
        if (process.env.PROJECT === 'bi') {
          var clipboardData = event.clipboardData || window.clipboardData
          if (!clipboardData) { return }
          var text = window.getSelection().toString()
          if (text) {
            event.preventDefault()
            if (process.env.NODE_ENV === 'production') {
              clipboardData.setData('text/plain', '版权为北京惠赢天下网络技术有限公司所有。\n 如有需要请联系本公司: 400-687-0066')
            } else {
              clipboardData.setData('text/plain', '如需调试请联系我')
            }
          }
        }
      }
    }
  }
</script>
<style type="text/scss" lang="scss" scoped>
  @import "src/styles/mixin.scss";

  .report-container {
    /*height: 100%;*/
    display: flex;
    max-width:100%;
    display: -mox-flex;
    display: -webkit-flex;
    display: -ms-flexbox;
    display:block\9;
    flex-direction: column;
    flex: 1;
    .report-warrper {
      display: flex;
      display: -mox-flex;
      display: -webkit-flex;
      display: -ms-flexbox;
      display:block\9;
      max-width:100%;
      flex-direction: column;
      flex: 1;
    }
    .report-info-all {
      display:block;
      margin-right: 20px;
    }
    .report-box {
      font-family: Tahoma, "Microsoft YaHei", "PingFang SC", Arial, sans-serif;
      font-size: 12px;
      height: 100%;
      position: relative;
      background-color: #F6F7F8;
      padding: 0 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/report/index.vue